export default {
  title: {
    en: 'Treat yourself to a new scented candle every month!',
  },
}
